import { z } from 'zod';

import { ForeclosureId } from '../BrandedIds';
import { BaseLoanEvent } from './BaseLoanEvent';

export const PauseForeclosureEvent = BaseLoanEvent.extend({
  type: z.literal('pauseForeclosure'),
  foreclosureId: ForeclosureId,
  comment: z.string().optional(),
});
export type PauseForeclosureEvent = z.infer<typeof PauseForeclosureEvent>;
